module.exports = __webpack_public_path__ + "img/frown.829dcfb1.svg";